module.exports = __webpack_public_path__ + "img/cart-icon.796ea24.svg";